"use client";

import { Mail, TrendingUp, Pencil, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  id: 1,
  icon: Mail,
  title: "Email List Building and Growth",
  subtitle: "We help restaurants accelerate subscriber acquisition through data-driven strategies. Build a robust email database that drives repeat visits and customer loyalty.",
  link: "#email-list-building"
}, {
  id: 2,
  icon: TrendingUp,
  title: "Data-Driven Campaign Strategy",
  subtitle: "Our team crafts targeted campaigns based on analytics and customer behavior. Maximize ROI with personalized messaging that resonates with your diners.",
  link: "#campaign-strategy"
}, {
  id: 3,
  icon: Pencil,
  title: "Copywriting and Content Creation",
  subtitle: "Compelling copy tailored to your restaurant's brand voice and culinary niche. Transform diners into loyal patrons with engaging email content.",
  link: "#copywriting"
}, {
  id: 4,
  icon: Zap,
  title: "System Integration with Reservation and POS Systems",
  subtitle: "Seamless integration with your existing reservation and point-of-sale systems. Streamline operations and enhance direct-to-consumer communication.",
  link: "#system-integration"
}];
export default function ServiceOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section className="relative bg-muted-light-background py-20">
      <div className="container mx-auto px-6 max-w-5xl">
        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 gap-8 transition-all duration-[150ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2.5"}`}>
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={service.id} data-index={i} className="group hover:-translate-y-1 hover:shadow-medium transition-all duration-[150ms] ease-out bg-background border border-border">
                <CardContent className="flex flex-col items-start text-left py-8 px-6">
                  <div className="mb-6 p-4 rounded-lg bg-primary-light text-foreground">
                    <Icon className="size-10" strokeWidth={1.5} />
                  </div>
                  <CardHeader className="px-0 pb-0">
                    <CardTitle className="text-2xl font-bold text-foreground ![margin:0px_7px_12px_5px] !w-[400px]">
                      {service.title}
                    </CardTitle>
                    <CardDescription className="text-base text-muted-foreground leading-relaxed max-w-none ![margin:0px_8px_0px_0px]">
                      {service.subtitle}
                    </CardDescription>
                  </CardHeader>
                  <div className="mt-6">
                    <Button asChild variant="outline" className="transition-all duration-[80ms] ease-in-out hover:scale-[1.02] hover:bg-primary-light hover:text-foreground hover:border-primary">
                      <Link to={service.link}>Read More</Link>
                    </Button>
                  </div>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}